// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import AccordionController from './accordion_controller';
application.register('accordion', AccordionController);

import AccessReminderModalController from './access_reminder_modal_controller';
application.register('access-reminder-modal', AccessReminderModalController);

import AutoSubmitController from './auto_submit_controller';
application.register('auto-submit', AutoSubmitController);

import BuildingsController from './buildings_controller';
application.register('buildings', BuildingsController);

import BulkImportController from './bulk_import_controller';
application.register('bulk-import', BulkImportController);

import BulkSelectController from './bulk_select_controller';
application.register('bulk-select', BulkSelectController);

import CarbonFootprintsController from './carbon_footprints_controller';
application.register('carbon-footprints', CarbonFootprintsController);

import CharacterCounterController from './character_counter_controller';
application.register('character-counter', CharacterCounterController);

import ChartController from './chart_controller';
application.register('chart', ChartController);

import CheckboxController from './checkbox_controller';
application.register('checkbox', CheckboxController);

import ConnectionController from './connection_controller';
application.register('connection', ConnectionController);

import DatepickerController from './datepicker_controller';
application.register('datepicker', DatepickerController);

import DecimalSeparatorController from './decimal_separator_controller';
application.register('decimal-separator', DecimalSeparatorController);

import DisableButtonController from './disable_button_controller';
application.register('disable-button', DisableButtonController);

import DetailedReportPdfController from './detailed_report_pdf_controller';
application.register('detailed-report-pdf', DetailedReportPdfController);

import MonthlyReportController from './monthly_report_controller';
application.register('monthly-report', MonthlyReportController);

import DmaCompletedController from './dma_completed_controller';
application.register('dma-completed', DmaCompletedController);

import DmaController from './dma_controller';
application.register('dma', DmaController);

import EntityWeightController from './entity_weight_controller';
application.register('entity-weight', EntityWeightController);

import DropdownController from './dropdown_controller';
application.register('dropdown', DropdownController);

import DocumentRemovalController from './document_removal_controller';
application.register('document-removal', DocumentRemovalController);

import FileFieldController from './file_field_controller';
application.register('file-field', FileFieldController);

import FilterMetersController from './filter_meters_controller';
application.register('filter-meters', FilterMetersController);

import FormulaTableEditorController from './formula_table_editor_controller';
application.register('formula-table-editor', FormulaTableEditorController);

import FiltersController from './filters_controller';
application.register('filters', FiltersController);

import FlashMessageController from './flash_message_controller';
application.register('flash-message', FlashMessageController);

import FocusedRowController from './focused_row_controller';
application.register('focused-row', FocusedRowController);

import FormController from './form_controller';
application.register('form', FormController);

import HubspotController from './hubspot_controller';
application.register('hubspot', HubspotController);

import ImageFieldController from './image_field_controller';
application.register('image-field', ImageFieldController);

import ImageUploadController from './image_upload_controller';
application.register('image-upload', ImageUploadController);

import IntegerInputController from './integer_input_controller';
application.register('integer-input', IntegerInputController);

import LabelsController from './labels_controller';
application.register('labels', LabelsController);

import MatterEvaluationController from './matter_evaluation_controller';
application.register('matter-evaluation', MatterEvaluationController);

import MeterController from './meter_controller';
application.register('meter', MeterController);

import ModalController from './modal_controller';
application.register('modal', ModalController);

import NumberInputLockController from './number_input_lock_controller';
application.register('number-input-lock', NumberInputLockController);

import OfflineStoreController from './offline_store_controller';
application.register('offline-store', OfflineStoreController);

import PaginationController from './pagination_controller';
application.register('pagination', PaginationController);

import PreservePageScrollController from './preserve_page_scroll_controller';
application.register('preserve-page-scroll', PreservePageScrollController);

import RangeFieldController from './range_field_controller';
application.register('range-field', RangeFieldController);

import ReadingController from './reading_controller';
application.register('reading', ReadingController);

import ReadingsTableController from './readings_table_controller';
application.register('readings-table', ReadingsTableController);

import RecaptchaController from './recaptcha_controller';
application.register('recaptcha', RecaptchaController);

import RevealController from './reveal_controller';
application.register('reveal', RevealController);

import ScoringUploadController from './scoring_upload_controller';
application.register('scoring-upload', ScoringUploadController);

import ScrollRefreshController from './scroll_refresh_controller';
application.register('scroll-refresh', ScrollRefreshController);

import SearchController from './search_controller';
application.register('search', SearchController);

import SearchableSelectController from './searchable_select_controller';
application.register('searchable-select', SearchableSelectController);

import SectionDataEntryFieldsController from './section_data_entry_fields_controller';
application.register('section-data-entry-fields', SectionDataEntryFieldsController);

import SignificanceAnalysisController from './significance_analysis_controller';
application.register('significance-analysis', SignificanceAnalysisController);

import SignificanceAnalysisFormController from './significance_analysis_form_controller';
application.register('significance-analysis-form', SignificanceAnalysisFormController);

import StandardFilterController from './standard_filter_controller';
application.register('standard-filter', StandardFilterController);

import StoreReadingsController from './store_readings_controller';
application.register('store-readings', StoreReadingsController);

import SyncReadingsController from './sync_readings_controller';
application.register('sync-readings', SyncReadingsController);

import TableContentController from './table_content_controller';
application.register('table-content', TableContentController);

import ThresholdController from './threshold_controller';
application.register('threshold', ThresholdController);

import TilesController from './tiles_controller';
application.register('tiles', TilesController);

import ToggleController from './toggle_controller';
application.register('toggle', ToggleController);

import TokenController from './token_controller';
application.register('token', TokenController);

import WarnOnLeaveController from './warn_on_leave_controller';
application.register('warn-on-leave', WarnOnLeaveController);

import ConfirmSubmitController from './confirm_submit_controller';
application.register('confirm-submit', ConfirmSubmitController);

import CollaboratorsController from './collaborators_controller';
application.register('collaborators', CollaboratorsController);

import CfcopyController from './cfcopy_controller';
application.register('cfcopy', CfcopyController);

import SelectWithCreateToggleController from './select_with_create_toggle_controller';
application.register('select-with-create-toggle', SelectWithCreateToggleController);

import WarnConsumptionController from './warn_consumption_controller';
application.register('warn-consumption', WarnConsumptionController);

import CurrencyController from './currency_controller';
application.register('currency', CurrencyController);

import WeightLogicController from './weight_logic_controller';
application.register('weight-logic', WeightLogicController);

import TwoStepModalController from './two_step_modal_controller';
application.register('two-step-modal', TwoStepModalController);

import PollutantEmissionsTableController from './pollutant_emissions_table_controller';
application.register('pollutant-emissions-table', PollutantEmissionsTableController);

import SitesTableController from './sites_table_controller';
application.register('sites-table', SitesTableController);

import BiodiversitySitesTableController from './biodiversity_sites_table_controller';
application.register('biodiversity-sites-table', BiodiversitySitesTableController);

import WasteTableController from './waste_table_controller';
application.register('waste-table', WasteTableController);

import KeyMaterialsTableController from './key_materials_table_controller';
application.register('key-materials-table', KeyMaterialsTableController);

import EmployeesByCountryTableController from './employees_by_country_table_controller';
application.register('employees-by-country-table', EmployeesByCountryTableController);

import PolicyContentTableController from './policy_content_table_controller';
application.register('policy-content-table', PolicyContentTableController);

import OmittedDisclosuresTableController from './omitted_disclosures_table_controller';
application.register('omitted-disclosures-table', OmittedDisclosuresTableController);

import ValueChainPartnersTableController from './value_chain_partners_table_controller';
application.register('value-chain-partners-table', ValueChainPartnersTableController);

import QuantitativeFieldsController from './quantitative_fields_controller';
application.register('quantitative-fields', QuantitativeFieldsController);

import ColorPreviewController from './color_preview_controller';
application.register('color-preview', ColorPreviewController);

import ReportCollaboratorsController from './report_collaborators_controller';
application.register('report-collaborators', ReportCollaboratorsController);

import EntityController from './entity_controller';
application.register('entity', EntityController);

import DateSelectController from './date_select_controller';
application.register('date-select', DateSelectController);

import NaceSectorTableController from './nace_sector_table_controller';
application.register('nace-sector-table', NaceSectorTableController);
